<template>
  <!-- prettier-ignore -->
  <index-content>
    <template #options>
      <nb-download :url="CUSTOMER_CATEGORY_CSV_URL" :params="condition" />
    </template>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" />
      <n-field-enum v-model="condition.type" enum-name="TransactionType" label="type" all-option />
      <n-field-enum v-model="condition.status" enum-name="CustomerCategoryStatus" label="status" all-option />
      <n-field-id v-model="condition.id" label="id" />
      <n-field-id v-model="condition.customerId" label="customerId" />
      <n-field-id v-model="condition.name" label="name" />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <thead>
          <tr>
            <th class="n-table-id">{{ $t('label.id') }}</th>
            <th class="col-weight-12">{{ $t('label.company') }}</th>
            <th class="col-weight-12">{{ $t('label.customerId') }}</th>
            <th class="col-weight-24">{{ $t('label.name') }}</th>
            <th class="col-weight-12">{{ $t('label.type') }}</th>
            <th class="col-weight-12">{{ $t('label.status') }}</th>
            <th class="n-table-timestamp">{{ $t('label.requestTime') }}</th>
            <th v-table-action>{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ row.id }}</td>
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td class="n-ellipsis">
              <n-modal-link name="customer.profile" :value="row.customerId" />
            </td>
            <td class="n-ellipsis">{{ row.name | hyphen }}</td>
            <td v-enums:TransactionType="row.type"></td>
            <td v-enums:CustomerCategoryStatus="row.status"></td>
            <td>{{ row.updateDatetime | datetime }}</td>
            <td class="n-button-box">
              <nb-modal @on-click="openModal(row)" />
            </td>
          </tr>
        </tbody>
      </table>
    </n-table>
  </index-content>
</template>

<script>
import CustomerView from './view';
import PaginateMixin from '@/mixins/paginate-mixin';
import ModalCustomerCategory from './ModalCustomerCategory';
import { CUSTOMER_CATEGORY_CSV_URL, fetch } from '@/api/customer/customer-customer-category';

export default CustomerView.extend({
  name: 'CustomerCustomerCategory',
  mixins: [PaginateMixin],
  data() {
    return {
      condition: {
        companyId: 0,
        id: null,
        name: null,
        customerId: null,
        type: 0,
        status: 0,
        from: this.oneWeekAgo,
        to: this.eod,
      },
      CUSTOMER_CATEGORY_CSV_URL,
    };
  },
  methods: {
    doSearch(params) {
      let p = { ...params, ...this.condition };
      return fetch(p);
    },
    parse(rows) {
      this.records = rows.records;
    },
    openModal(model = {}) {
      this.createModal(ModalCustomerCategory, { model, on: this });
    },
    doLogout(id) {
      return logout(id);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/style/table';

.n-table {
  min-width: 1080px;

  th.rw-action {
    width: 4rem;
  }

  th.ro-action {
    width: 4.5rem;
  }
}
</style>
